var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "#3A3275",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2076 44.2921C46.3005 44.385 46.3742 44.4953 46.4245 44.6167C46.4747 44.7381 46.5006 44.8682 46.5006 44.9996C46.5006 45.131 46.4747 45.2611 46.4245 45.3825C46.3742 45.5039 46.3005 45.6142 46.2076 45.7071C46.1147 45.8 46.0044 45.8737 45.883 45.924C45.7616 45.9743 45.6315 46.0001 45.5001 46.0001C45.3687 46.0001 45.2386 45.9743 45.1172 45.924C44.9958 45.8737 44.8855 45.8 44.7926 45.7071L36.5001 37.4133L28.2076 45.7071C28.0199 45.8947 27.7654 46.0001 27.5001 46.0001C27.2347 46.0001 26.9802 45.8947 26.7926 45.7071C26.6049 45.5194 26.4995 45.2649 26.4995 44.9996C26.4995 44.7342 26.6049 44.4797 26.7926 44.2921L35.0863 35.9996L26.7926 27.7071C26.6049 27.5194 26.4995 27.2649 26.4995 26.9996C26.4995 26.7342 26.6049 26.4797 26.7926 26.2921C26.9802 26.1044 27.2347 25.999 27.5001 25.999C27.7654 25.999 28.0199 26.1044 28.2076 26.2921L36.5001 34.5858L44.7926 26.2921C44.9802 26.1044 45.2347 25.999 45.5001 25.999C45.7654 25.999 46.0199 26.1044 46.2076 26.2921C46.3952 26.4797 46.5006 26.7342 46.5006 26.9996C46.5006 27.2649 46.3952 27.5194 46.2076 27.7071L37.9138 35.9996L46.2076 44.2921Z",
    fill: "#3A3275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.384c36a616fe8298fdf44e4574ebd722.svg";
export { ForwardRef as ReactComponent };